import React from "react";

import { Row, Col, Dropdown, Menu, Card } from "antd";
import { Margin } from "styled-components-spacing";
import { CaretLeftOutlined } from "@ant-design/icons";
import Center from "react-center";
import { DownOutlined } from "@ant-design/icons";
import moment from "jalali-moment";

// CSS Files
import "../../Fonts/Fonts.css";
import "../../Statics/HomePage/HomePageMenu.css";
import "../../Statics/HomePage/MobileHPMenu.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

//Styles
const SubMenuLapDesk = {
  fontFamily: "IranSans",
  direction: "rtl",
  textAlign: "right",
};

const SubMenuMobile = {
  fontFamily: "IranSans",
  textAlign: "right",
  direction: "rtl",
  fontSize: ".8em",
  color: "#333",
};
const SubMenuIconLapDesk = {
  color: "#184564",
  fontSize: "1.3em",
};

const SubMenuGroupLapDesk = {
  direction: "rtl",
  textAlign: "right",
  padding: "20px",
};

const ContactUsMobile = (props) => (
  <Card style={{ zIndex: "100" }}>
    <ul style={{ listStyleType: "none", textAlign: "right", direction: "rtl" }}>
      <li>
        <a
          style={SubMenuMobile}
          onClick={() => props.history.push("/contactus")}
          class="submenu-link"
        >
          ارتباط با ما
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          onClick={() => props.history.push("/branches")}
          class="submenu-link"
        >
          شعب 
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          onClick={() => props.history.push("/workwithus")}
          class="submenu-link"
        >
          همکاری با ما
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          onClick={() => props.history.push("/festival")}
          class="submenu-link"
        >
          جشنواره پایان نامه ای
        </a>
      </li>
    </ul>
  </Card>
);

const InsuranceKnowledgeMobile = (props) => (
  <Card style={{ zIndex: "100" }}>
    <ul style={{ listStyleType: "none", textAlign: "right", direction: "rtl" }}>
      <li>
        <a
          style={SubMenuMobile}
          onClick={() => props.history.push("/approvals")}
          class="submenu-link"
        >
          مصوبات شورای عالی بیمه
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          onClick={() => props.history.push("/laws")}
          class="submenu-link"
        >
          قوانین و مقررات بیمه
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          onClick={() => props.history.push("/booksarticles")}
          class="submenu-link"
        >
          کتاب، مقالات، پایان نامه‌ها
        </a>
      </li>
      <li>
        <a style={SubMenuMobile} 
          onClick={() =>
            props.history.push("/ecosystem")
          }
         class="submenu-link">
          اکوسیستم صنعت بیمه
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          href="https://www.centinsur.ir/index.aspx?siteid=1&fkeyid=&siteid=1&pageid=229"
          target="_blank"
          class="submenu-link"
        >
          کارگزارن بیمه
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          href="https://www.centinsur.ir/index.aspx?siteid=1&fkeyid=&siteid=1&pageid=262"
          target="_blank"
          class="submenu-link"
        >
          نمایندگان بیمه
        </a>
      </li>
      {/* <li>
        <a style={SubMenuMobile} href="#" class="submenu-link">
          آمار صنعت بیمه
        </a>
      </li> */}
      
      <li>
        <a
          style={SubMenuMobile}
          href="http://moraghebbime.ir/%d8%b1%d8%a7%d8%af%db%8c%d9%88-%d8%a8%db%8c%d9%85%d9%87/"
          target="_blank"
          class="submenu-link"
        >
          رادیو بیمه
        </a>
      </li>
    </ul>
  </Card>
);
const OurCompaniesMobile = (
  <Card style={{ zIndex: "100" }}>
    <ul style={{ listStyleType: "none", textAlign: "right", direction: "rtl" }}>
      <li>
        <a
          style={SubMenuMobile}
          href="http://arzyabip.com/"
          target="_blank"
          class="submenu-link"
        >
          ارزیابان ایرانیان پوشش
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          href="http://andishkadebime.ir/"
          target="_blank"
          class="submenu-link"
        >
          اندیشکده بیمه
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          href="http://moraghebbime.ir/"
          target="_blank"
          class="submenu-link"
        >
          مراقب بیمه
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          href="http://sanaap.com/"
          target="_blank"
          class="submenu-link"
        >
          سناپ
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          href="https://dadgarbime.ir/"
          target="_blank"
          class="submenu-link"
        >
          دادگر بیمه
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          href="http://hamiarbime.ir/"
          target="_blank"
          class="submenu-link"
        >
          همیار بیمه
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          href="http://kankashbimeh.ir/"
          target="_blank"
          class="submenu-link"
        >
          کنکاش بیمه
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          href="https://dadrasbime.ir/"
          target="_blank"
          class="submenu-link"
        >
          دادرس بیمه
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          href="https://ipseir.ir/"
          target="_blank"
          class="submenu-link"
        >
          آژانس بیمه
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          href="https://emdadpooshesh.com/"
          class="submenu-link"
        >
          امداد و نجات
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          href="https://separ.info/"
          target="_blank"
          class="submenu-link"
        >
         سپر
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          href="http://ipteach.ir/"
          target="_blank"
          class="submenu-link"
        >
          آموزشگاه آزاد فنی و حرفه ایی
        </a>
      </li>
    </ul>
  </Card>
);

const OurServicesMobile = (props) => (
  <Card style={{ zIndex: "100" }}>
    <ul style={{ listStyleType: "none", textAlign: "right", direction: "rtl" }}>
      <li>
        <a
          style={SubMenuMobile}
          onClick={() => props.history.push("/ourservices/1")}
          class="submenu-link"
        >
          ارزیابی خسارت
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          onClick={() => props.history.push("/ourservices/2")}
          class="submenu-link"
        >
          ارزیابی ریسک
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          onClick={() => props.history.push("/ourservices/3")}
          class="submenu-link"
        >
          ارزیابی ایمنی
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          onClick={() => props.history.push("/ourservices/4")}
          class="submenu-link"
        >
          ارزش گذاری
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          onClick={() => props.history.push("/ourservices/5")}
          class="submenu-link"
        >
          آموزش
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          onClick={() => props.history.push("/ourservices/6")}
          class="submenu-link"
        >
          حسابرسی
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          onClick={() => props.history.push("/ourservices/7")}
          class="submenu-link"
        >
          حقوقی
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          onClick={() => props.history.push("/ourservices/8")}
          class="submenu-link"
        >
          آکچوئری
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          onClick={() => props.history.push("/ourservices/9")}
          class="submenu-link"
        >
          داوری
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          onClick={() => props.history.push("/ourservices/10")}
          class="submenu-link"
        >
          تحقیق
        </a>
      </li>
      
      <li>
        <a
          style={SubMenuMobile}
          onClick={() => props.history.push("/ourservices/11")}
          class="submenu-link"
        >
          سامانه مشاوره
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          onClick={() => props.history.push("/ourservices/12")}
          class="submenu-link"
        >
          TPA
        </a>
      </li>
    </ul>
  </Card>
);
const AboutUsMobile = (props) => (
  <Card style={{ zIndex: "100" }}>
    <ul style={{ listStyleType: "none", textAlign: "right", direction: "rtl" }}>
      <li>
        <a
          style={SubMenuMobile}
          onClick={() => props.history.push("/aboutus")}
          class="submenu-link"
        >
          معرفی ایرانیان پوشش
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          onClick={() => props.history.push("/ourcompanies")}
          class="submenu-link"
        >
          معرفی شرکت های ما
        </a>
      </li>
      {/* <li>
        <a
          style={SubMenuMobile}
          onClick={() => props.history.push("/managermessage")}
          class="submenu-link"
        >
          پیام مدیرعامل
        </a>
      </li> */}
      <li>
        <a
          style={SubMenuMobile}
          onClick={() => props.history.push("/humanresource")}
          class="submenu-link"
        >
          سرمایه انسانی
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          onClick={() => props.history.push("/imagegallery")}
          class="submenu-link"
        >
          چند رسانه ای
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          onClick={() => props.history.push("/rewards")}
          class="submenu-link"
        >
          جوایز و افتخارات
        </a>
      </li>
    </ul>
  </Card>
);
const Navbar = (props) => {
  const history = useHistory();
  const ElctronicServicesMobile = (props) => (
    <Card style={{ zIndex: "100" }}>
    <ul style={{ listStyleType: "none", textAlign: "right", direction: "rtl" }}>
      {/* <li>
        <a
          style={SubMenuMobile}
          href="https://ipinsur.com/customer/"
          target="_blank"
          class="submenu-link"
        >
          اعلام خسارت
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          href="https://ipinsur.com/customer/FollowUpFile.aspx"
          target="_blank"
          class="submenu-link"
        >
          پیگیری پرونده
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          href="https://ipinsur.com/customer/Complaint.aspx"
          target="_blank"
          class="submenu-link"
        >
          ثبت شکایت
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          href="https://ipinsur.com/login.aspx?ReturnUrl=%2f"
          target="_blank"
          class="submenu-link"
        >
          پورتال خسارت (قدیم)
        </a>
      </li> */}
      <li>
        <a
          style={SubMenuMobile}
          href="http://IPAutomation.arzyab.net"
          target="_blank"
          class="submenu-link"
        >
          اتوماسیون اداری (ستاد)
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          href="http://178.252.167.58/Account/Login?ReturnUrl=%2f"
          target="_blank"
          class="submenu-link"
        >
          اتوماسیون اداری (شهرستان ها)
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          href="http://m50.iranianpooshesh.com/"
          target="_blank"
          class="submenu-link"
        >
          پورتال ماده ۵۰ (بیمه ایران)
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          href="https://asiam50.ir/asia-maade50"
          target="_blank"
          class="submenu-link"
        >
          پورتال ماده ۵۰ (بیمه آسیا)
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          href="https://car-portal.iranianpooshesh.com/"
          target="_blank"
          class="submenu-link"
        >
           پورتال اتومبیل (جدید)
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          href="https://estate-portal.iranianpooshesh.com/login"
          target="_blank"
          class="submenu-link"
        >
          پورتال اموال (جدید)
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
          href="http://193.176.242.187/login"
          target="_blank"
          class="submenu-link"
        >
           پورتال درمان (جدید)
        </a>
      </li>
      <li>
        <a
          style={SubMenuMobile}
         onClick={()=>history.push("/download-app-sanaap")}
          target="_blank"
          class="submenu-link"
        >
          اپلیکیشن سپر
        </a>
      </li>
      <li>
      <a
        style={SubMenuMobile}
       onClick={()=>history.push("/download-app-arzyab")}
        target="_blank"
        class="submenu-link"
      >
        اپلیکیشن ارزیاب اتومبیل
      </a>
    </li>
    <li>
      <a
        style={SubMenuMobile}
       onClick={()=>history.push("/download-app-arzyab-amval")}
        target="_blank"
        class="submenu-link"
      >
        اپلیکیشن ارزیاب اموال
      </a>
    </li>
    </ul>
  </Card>
  );
  return props.size === "laptopdesktop" ? (
    <div style={{ backgroundColor: "#174561" }}>
      <Row>
        <Col span={1}></Col>
        <Col span={4} style={{ direction: "rtl", textAlign: "right" }}>
          <p
            style={{
              fontFamily: "IranNastaliq",
              fontSize: "1em",
              color: "#bdc3c7",
              marginTop: "20px",
            }}
          >
            زنجیره صنعت بیمه با <span style={{ color: "#e13024" }}>ما</span>{" "}
            کامل می شود
          </p>

          {/* <p style={{ fontFamily: "IranSans", fontSize: ".8em", color: "#57747E", marginTop: "10px" }}><span className="enBorderStyle"><a>EN</a></span><a>فا</a></p> */}
        </Col>
        <Col span={2}></Col>
        <Col span={13} style={{ direction: "rtl", textAlign: "right" }}>
          <Row>
            <p
              style={{
                fontFamily: "IranSans",
                fontSize: ".8em",
                color: "#57747E",
                marginTop: "10px",
                padding: "5px",
              }}
            >
              {moment().locale("fa").format("dddd,D MMMM  YYYY")}
            </p>
          </Row>
          <Row>
            <Col span={13}>
              <hr
                style={{
                  border: "0.01em solid #57747E",
                  opacity: "100%",
                  marginTop: "-15px",
                  width: "100%",
                  textAlign: "right",
                  direction: "right",
                }}
              />
            </Col>
            <Col span={11}></Col>
          </Row>
        </Col>
        <Col span={3}>
          <Center>
            <img
              className="NavbarLogo"
              src={require("../../Imgs/HomePage/navbarLogo.png")}
            />
          </Center>
        </Col>
        <Col span={1}></Col>
      </Row>
      <Row className="navbarMarginTop">
        <Col span={4} style={{ textAlign: "right", direction: "rtl" }}></Col>
        <Col span={16}>
          <div>
            <div id="navigation">
              <div class="items-wrapper">
                <Row style={{ textAlign: "right" }}>
                  <Col span={24}>
                    <div class="item">
                      <a href="#" class="item-link">
                        تماس با ما
                      </a>
                      <div class="arrow"></div>
                      <div class="submenu-wrapper">
                        <div class="item-submenu">
                          <Row>
                            <Col span={7} style={SubMenuGroupLapDesk}>
                              <div class="submenu-group">
                                <p
                                  style={SubMenuLapDesk}
                                  class="submenu-link-master"
                                >
                                  تماس با ما
                                </p>
                                <a
                                  style={SubMenuLapDesk}
                                  onClick={() =>
                                    props.history.push("/contactus")
                                  }
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />
                                  ارتباط با ما
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  onClick={() =>
                                    props.history.push("/branches")
                                  }
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />
                                  شعب
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  onClick={() =>
                                    props.history.push("/workwithus")
                                  }
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />
                                  همکاری با ما
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  onClick={() =>
                                    props.history.push("/festival")
                                  }
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />
                                  جشنواره پایان نامه ای
                                </a>
                              </div>
                            </Col>
                            <Col span={7}></Col>
                            <Col span={8}></Col>
                            <Col span={2}></Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                    {/* <div class="item">
                                                <a href="https://ipinsur.com/login.aspx?ReturnUrl=%2f/" class="item-link">پورتال خسارت</a>
                                            </div> */}
                    <div class="item">
                      <a
                        onClick={() => props.history.push("/responsibility")}
                        class="item-link"
                      >
                        مسئولیت های اجتماعی
                      </a>
                    </div>
                    <div class="item">
                      <a href="#" class="item-link">
                        خدمات الکترونیکی
                      </a>
                      <div class="arrow"></div>
                      <div class="submenu-wrapper">
                        <div class="item-submenu">
                          <Row>
                            {/* <Col span={7} style={SubMenuGroupLapDesk}>
                              <div class="submenu-group">
                                <p
                                  style={SubMenuLapDesk}
                                  href="#"
                                  class="submenu-link-master"
                                >
                                  پیوند ها
                                </p>

                                <a
                                  style={SubMenuLapDesk}
                                  href="https://ipinsur.com/customer/"
                                  target="_blank"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  اعلام خسارت
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  href="https://ipinsur.com/customer/FollowUpFile.aspx"
                                  target="_blank"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  پیگیری پرونده
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  href="https://ipinsur.com/customer/Complaint.aspx"
                                  target="_blank"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  ثبت شکایت
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  href="https://ipinsur.com/login.aspx?ReturnUrl=%2f"
                                  target="_blank"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  پورتال خسارت (قدیم)
                                </a>
                              </div>
                            </Col> */}
                            <Col span={7} style={SubMenuGroupLapDesk}>
                              <div class="submenu-group">
                                <p
                                  // style={{ visibility: "hidden" }}
                                  href="#"
                                  class="submenu-link-master"
                                >
                                  پیوند ها
                                </p>

                                <a
                                  style={SubMenuLapDesk}
                                  href="http://IPAutomation.arzyab.net"
                                  target="_blank"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  اتوماسیون اداری (ستاد)
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  href="http://178.252.167.58/Account/Login?ReturnUrl=%2f"
                                  target="_blank"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  اتوماسیون اداری (شهرستان ها)
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  href="http://m50.iranianpooshesh.com/"
                                  target="_blank"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  پورتال ماده ۵۰ (بیمه ایران)
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  href="https://asiam50.ir/asia-maade50"
                                  target="_blank"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  پورتال ماده ۵۰ (بیمه آسیا)
                                </a>
                              </div>
                            </Col>
                            <Col span={7} style={SubMenuGroupLapDesk}>
                              <div class="submenu-group">
                                <p
                                  style={{ visibility: "hidden" }}
                                  href="#"
                                  class="submenu-link-master"
                                >
                                  پیوند ها
                                </p>

                                <a
                                  style={SubMenuLapDesk}
                                  href="https://car-portal.iranianpooshesh.com/"
                                  target="_blank"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  پورتال اتومبیل (جدید)
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  href="https://estate-portal.iranianpooshesh.com/login"
                                  target="_blank"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  پورتال اموال (جدید)
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  href="http://193.176.242.187/login"
                                  target="_blank"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  پورتال درمان (جدید)
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  onClick={()=>history.push("/download-app-sanaap")}
                                  target="_blank"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                اپلیکیشن سپر
                                </a>
                              </div>
                            </Col>
                            <Col span={7} style={SubMenuGroupLapDesk}>
                              <div class="submenu-group">
                                <p
                                  style={{ visibility: "hidden" }}
                                  href="#"
                                  class="submenu-link-master"
                                >
                                  پیوند ها
                                </p>

                                <a
                                 style={SubMenuLapDesk}
                                 onClick={()=>history.push("/download-app-arzyab")}
                                 target="_blank"
                                 class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  اپلیکیشن ارزیاب اتومبیل
                                </a>
                                <a
                                 style={SubMenuLapDesk}
                                 onClick={()=>history.push("/download-app-arzyab-amval")}
                                 target="_blank"
                                 class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  اپلیکیشن ارزیاب اموال
                                </a>  
                              </div>
                            </Col>
                            <Col span={3}></Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                    <div class="item">
                      <a href="#" class="item-link">
                        دانش بیمه
                      </a>
                      <div class="arrow"></div>
                      <div class="submenu-wrapper">
                        <div class="item-submenu">
                          <Row>
                            <Col span={7} style={SubMenuGroupLapDesk}>
                              <div class="submenu-group">
                                <p
                                  style={SubMenuLapDesk}
                                  href="#"
                                  class="submenu-link-master"
                                >
                                  دانش بیمه
                                </p>
                                <a
                                  style={SubMenuLapDesk}
                                  onClick={() =>
                                    props.history.push("/approvals")
                                  }
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  مصوبات شورای عالی بیمه
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  onClick={() => props.history.push("/laws")}
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  قوانین و مقررات بیمه
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  onClick={() =>
                                    props.history.push("/booksarticles")
                                  }
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  کتاب، مقالات، پایان نامه‌ها
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  onClick={() =>
                                    props.history.push("/ecosystem")
                                  }
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  اکوسیستم صنعت بیمه
                                </a>
                              </div>
                            </Col>
                            <Col span={7} style={SubMenuGroupLapDesk}>
                              <div class="submenu-group">
                                <p
                                  style={{ visibility: "hidden" }}
                                  href="#"
                                  class="submenu-link-master"
                                >
                                  دانش بیمه
                                </p>
                                <a
                                  href="https://www.centinsur.ir/index.aspx?siteid=1&fkeyid=&siteid=1&pageid=229"
                                  target="_blank"
                                  style={SubMenuLapDesk}
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  کارگزارن بیمه
                                </a>
                                <a
                                  href="https://www.centinsur.ir/index.aspx?siteid=1&fkeyid=&siteid=1&pageid=262"
                                  target="_blank"
                                  style={SubMenuLapDesk}
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  نمایندگان بیمه
                                </a>
                                {/* <a
                                  style={SubMenuLapDesk}
                                  href="#"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  آمار صنعت بیمه
                                </a> */}

                                <a
                                  style={SubMenuLapDesk}
                                  href="http://moraghebbime.ir/%d8%b1%d8%a7%d8%af%db%8c%d9%88-%d8%a8%db%8c%d9%85%d9%87/"
                                  target="_blank"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />
                                  رادیو بیمه
                                </a>
                              </div>
                            </Col>
                            <Col span={8}></Col>
                            <Col span={2}></Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                    <div class="item">
                      <a href="#" class="item-link">
                        شرکت‌های ما
                      </a>
                      <div class="arrow"></div>
                      <div class="submenu-wrapper">
                        <div class="item-submenu">
                          <Row>
                            <Col span={7} style={SubMenuGroupLapDesk}>
                              <div class="submenu-group">
                                <p
                                  style={SubMenuLapDesk}
                                  href="#"
                                  class="submenu-link-master"
                                >
                                  شرکت‌های ما
                                </p>
                                <a
                                  style={SubMenuLapDesk}
                                  href="http://arzyabip.com/"
                                  target="_blank"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  ارزیابان ایرانیان پوشش
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  href="http://andishkadebime.ir/"
                                  target="_blank"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  اندیشکده بیمه
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  href="http://moraghebbime.ir/"
                                  target="_blank"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  مراقب بیمه
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  href="http://sanaap.com/"
                                  target="_blank"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  سناپ
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  href="https://dadgarbime.ir/"
                                  target="_blank"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  دادگر بیمه
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  href="http://hamiarbime.ir/"
                                  target="_blank"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  همیار بیمه
                                </a>
                              </div>
                            </Col>
                            <Col span={7} style={SubMenuGroupLapDesk}>
                              <div class="submenu-group">
                                <p
                                  style={{ visibility: "hidden" }}
                                  href="#"
                                  target="_blank"
                                  class="submenu-link-master"
                                >
                                  شرکت‌های ما
                                </p>
                                <a
                                  style={SubMenuLapDesk}
                                  href="http://kankashbimeh.ir/"
                                  target="_blank"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  کنکاش بیمه
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  href="https://dadrasbime.ir/"
                                  target="_blank"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  دادرس بیمه
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  href="https://ipseir.ir/"
                                  target="_blank"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  آژانس بیمه
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  href="https://emdadpooshesh.com/"
                                  target="_blank"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  امداد و نجات
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  href="https://separ.info/"
                                  target="_blank"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                 سپر
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  href="http://ipteach.ir/"
                                  target="_blank"
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  آموزشگاه آزاد فنی و حرفه ایی
                                </a>
                              </div>
                            </Col>
                            <Col span={8}></Col>
                            <Col span={2}></Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                    <div class="item">
                      <a href="#" class="item-link">
                        محصولات و نوآوری
                      </a>
                      <div class="arrow"></div>
                      <div class="submenu-wrapper">
                        <div class="item-submenu">
                          <Row>
                            <Col span={7} style={SubMenuGroupLapDesk}>
                              <div class="submenu-group">
                                <p
                                  style={SubMenuLapDesk}
                                  href="#"
                                  class="submenu-link-master"
                                >
                                  محصولات و نوآوری
                                </p>
                                <a
                                  style={SubMenuLapDesk}
                                  onClick={() =>
                                    props.history.push("/ourservices/1")
                                  }
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  ارزیابی خسارت
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  onClick={() =>
                                    props.history.push("/ourservices/2")
                                  }
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  ارزیابی ریسک
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  onClick={() =>
                                    props.history.push("/ourservices/3")
                                  }
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  ارزیابی ایمنی
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  onClick={() =>
                                    props.history.push("/ourservices/4")
                                  }
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  ارزش گذاری
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  onClick={() =>
                                    props.history.push("/ourservices/5")
                                  }
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  آموزش
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  onClick={() =>
                                    props.history.push("/ourservices/6")
                                  }
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  حسابرسی
                                </a>
                              </div>
                            </Col>
                            <Col span={7} style={SubMenuGroupLapDesk}>
                              <div class="submenu-group">
                                <p
                                  style={{ visibility: "hidden" }}
                                  href="#"
                                  class="submenu-link-master"
                                >
                                  محصولات و نوآوری
                                </p>
                                <a
                                  style={SubMenuLapDesk}
                                  onClick={() =>
                                    props.history.push("/ourservices/7")
                                  }
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  حقوقی
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  onClick={() =>
                                    props.history.push("/ourservices/8")
                                  }
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  آکچوئری
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  onClick={() =>
                                    props.history.push("/ourservices/9")
                                  }
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  داوری
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  onClick={() =>
                                    props.history.push("/ourservices/10")
                                  }
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  تحقیق
                                </a>

                                <a
                                  style={SubMenuLapDesk}
                                  onClick={() =>
                                    props.history.push("/ourservices/11")
                                  }
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  سامانه مشاوره
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  onClick={() =>
                                    props.history.push("/ourservices/12")
                                  }
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  TPA
                                </a>
                              </div>
                            </Col>
                            <Col span={8}></Col>
                            <Col span={2}></Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                    <div class="item">
                      <a href="#" class="item-link">
                        درباره ما
                      </a>
                      <div class="arrow"></div>
                      <div class="submenu-wrapper">
                        <div class="item-submenu">
                          <Row>
                            <Col span={7} style={SubMenuGroupLapDesk}>
                              <div class="submenu-group">
                                <p class="submenu-link-master">درباره ما</p>
                                <a
                                  style={SubMenuLapDesk}
                                  onClick={() => props.history.push("/aboutus")}
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  معرفی ایرانیان پوشش
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  onClick={() =>
                                    props.history.push("/ourcompanies")
                                  }
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  معرفی شرکت های ما
                                </a>
                                {/* <a
                                  style={SubMenuLapDesk}
                                  onClick={() =>
                                    props.history.push("/managermessage")
                                  }
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  پیام مدیرعامل
                                </a> */}
                              </div>
                            </Col>
                            <Col span={7} style={SubMenuGroupLapDesk}>
                              <div class="submenu-group">
                                <p
                                  style={{ visibility: "hidden" }}
                                  class="submenu-link-master"
                                >
                                  درباره ما
                                </p>
                                <a
                                  style={SubMenuLapDesk}
                                  onClick={() =>
                                    props.history.push("/humanresource")
                                  }
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />{" "}
                                  سرمایه انسانی
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  onClick={() =>
                                    props.history.push("/imagegallery")
                                  }
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />
                                  چند رسانه ای
                                </a>
                                <a
                                  style={SubMenuLapDesk}
                                  onClick={() => props.history.push("/rewards")}
                                  class="submenu-link"
                                >
                                  <CaretLeftOutlined
                                    style={SubMenuIconLapDesk}
                                  />
                                  جوایز و افتخارات
                                </a>
                              </div>
                            </Col>
                            <Col span={8}></Col>
                            <Col span={2}></Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                    <div class="item" style={{ marginRight: "-15px" }}>
                      <a href="/" class="item-link">
                        صفحه نخست
                      </a>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Col>
        <Col span={4}></Col>
      </Row>
    </div>
  ) : props.size === "tablet" ? (
    <div>
      <header className="header">
        <nav className="primary">
          <div className="header__container">
            <Row>
              <Col span={3}>
                <img
                  className="NavbarLogo"
                  src={require("../../Imgs/HomePage/navbarLogo.png")}
                />
              </Col>
              <Col span={3}></Col>
              <Col span={12}>
                <p
                  style={{
                    fontFamily: "IranNastaliq",
                    fontSize: "1em",
                    color: "#bdc3c7",
                    marginTop: "30px",
                    textAlign: "center",
                  }}
                >
                  زنجیره صنعت بیمه با{" "}
                  <span style={{ color: "#e13024" }}>ما</span> کامل می شود
                </p>
              </Col>
              <Col span={3}></Col>
              <Col span={3}>
                <ul>
                  <li className="mobile-nav">
                    <button id="nav-toggle" style={{ paddingRight: "15px" }}>
                      <span className="menu"></span>
                    </button>
                  </li>
                </ul>
              </Col>
            </Row>
          </div>
        </nav>
      </header>
      <nav className="mobile">
        <ul style={{ direction: "rtl" }}>
          <li className="link">
            <a href="/" style={SubMenuMobile}>
              صفحه نخست
            </a>
          </li>
          <li className="link">
            <Dropdown overlay={() => AboutUsMobile(props)} trigger={["click"]}>
              <a
                style={SubMenuMobile}
                className="ant-dropdown-link NavbarItem"
                onClick={(e) => e.preventDefault()}
              >
                درباره ما <DownOutlined />
              </a>
            </Dropdown>
          </li>
          <li className="link">
            <Dropdown
              overlay={() => OurServicesMobile(props)}
              trigger={["click"]}
            >
              <a
                style={SubMenuMobile}
                className="ant-dropdown-link NavbarItem"
                onClick={(e) => e.preventDefault()}
              >
                محصولات و نوآوری
                <DownOutlined />
              </a>
            </Dropdown>
          </li>
          <li className="link">
            <Dropdown
              overlay={() => OurCompaniesMobile(props)}
              trigger={["click"]}
            >
              <a
                style={SubMenuMobile}
                className="ant-dropdown-link NavbarItem"
                onClick={(e) => e.preventDefault()}
              >
                شرکت های ما <DownOutlined />
              </a>
            </Dropdown>
          </li>
          <li className="link">
            <Dropdown
              overlay={() => InsuranceKnowledgeMobile(props)}
              trigger={["click"]}
            >
              <a
                style={SubMenuMobile}
                className="ant-dropdown-link NavbarItem"
                onClick={(e) => e.preventDefault()}
              >
                دانش بیمه <DownOutlined />
              </a>
            </Dropdown>
          </li>
          <li className="link">
            <Dropdown
              overlay={() => ElctronicServicesMobile(props)}
              trigger={["click"]}
            >
              <a
                style={SubMenuMobile}
                className="ant-dropdown-link NavbarItem"
                onClick={(e) => e.preventDefault()}
              >
                خدمات الکترونیکی <DownOutlined />
              </a>
            </Dropdown>
          </li>
          <li className="link">
            <a
              href="/responsibility"
              className="NavbarItem"
              style={SubMenuMobile}
            >
              مسئولیت های اجتماعی
            </a>
          </li>
          {/* <li className="link">
                                <a href="https://ipinsur.com/login.aspx?ReturnUrl=%2f/" className="NavbarItem" style={SubMenuMobile}>پورتال خسارت</a>
                            </li> */}
          <li className="link">
            <Dropdown
              overlay={() => ContactUsMobile(props)}
              trigger={["click"]}
            >
              <a
                style={SubMenuMobile}
                className="ant-dropdown-link NavbarItem"
                onClick={(e) => e.preventDefault()}
              >
                تماس با ما <DownOutlined />
              </a>
            </Dropdown>
          </li>
          {/* <li>
                            <p style={{ fontFamily: "IranSans", fontSize: ".8em", color: "#57747E"}}><a>فا</a><span className="enBorderStyle"><a>EN</a></span></p>
                        </li> */}
        </ul>
      </nav>
    </div>
  ) : (
    <div>
      <header className="header">
        <nav className="primary">
          <div className="header__container">
            <Row>
              <Col span={3}>
                <img
                  className="NavbarLogo"
                  src={require("../../Imgs/HomePage/navbarLogo.png")}
                />
              </Col>
              <Col span={3}></Col>
              <Col span={12}>
                <p
                  style={{
                    fontFamily: "IranNastaliq",
                    fontSize: "1em",
                    color: "#bdc3c7",
                    marginTop: "30px",
                    textAlign: "center",
                  }}
                >
                  زنجیره صنعت بیمه با{" "}
                  <span style={{ color: "#e13024" }}>ما</span> کامل می شود
                </p>
              </Col>
              <Col span={3}></Col>
              <Col span={3}>
                <ul>
                  <li className="mobile-nav">
                    <button id="nav-toggle" style={{ paddingRight: "15px" }}>
                      <span className="menu"></span>
                    </button>
                  </li>
                </ul>
              </Col>
            </Row>
          </div>
        </nav>
      </header>
      <nav className="mobile">
        <ul style={{ direction: "rtl" }}>
          <li className="link">
            <a href="/" style={SubMenuMobile}>
              صفحه نخست
            </a>
          </li>
          <li className="link">
            <Dropdown overlay={() => AboutUsMobile(props)} trigger={["click"]}>
              <a
                style={SubMenuMobile}
                className="ant-dropdown-link NavbarItem"
                onClick={(e) => e.preventDefault()}
              >
                درباره ما <DownOutlined />
              </a>
            </Dropdown>
          </li>
          <li className="link">
            <Dropdown
              overlay={() => OurServicesMobile(props)}
              trigger={["click"]}
            >
              <a
                style={SubMenuMobile}
                className="ant-dropdown-link NavbarItem"
                onClick={(e) => e.preventDefault()}
              >
                محصولات و نوآوری <DownOutlined />
              </a>
            </Dropdown>
          </li>
          <li className="link">
            <Dropdown
              overlay={() => OurCompaniesMobile(props)}
              trigger={["click"]}
            >
              <a
                style={SubMenuMobile}
                className="ant-dropdown-link NavbarItem"
                onClick={(e) => e.preventDefault()}
              >
                شرکت های ما <DownOutlined />
              </a>
            </Dropdown>
          </li>
          <li className="link">
            <Dropdown
              overlay={() => InsuranceKnowledgeMobile(props)}
              trigger={["click"]}
            >
              <a
                style={SubMenuMobile}
                className="ant-dropdown-link NavbarItem"
                onClick={(e) => e.preventDefault()}
              >
                دانش بیمه <DownOutlined />
              </a>
            </Dropdown>
          </li>
          <li className="link">
            <Dropdown
              overlay={() => ElctronicServicesMobile(props)}
              trigger={["click"]}
            >
              <a
                style={SubMenuMobile}
                className="ant-dropdown-link NavbarItem"
                onClick={(e) => e.preventDefault()}
              >
                خدمات الکترونیکی <DownOutlined />
              </a>
            </Dropdown>
          </li>
          <li className="link">
            <a
              href="/responsibility"
              className="NavbarItem"
              style={SubMenuMobile}
            >
              مسئولیت های اجتماعی
            </a>
          </li>
          {/* <li className="link">
                                <a href="https://ipinsur.com/login.aspx?ReturnUrl=%2f/" className="NavbarItem" style={SubMenuMobile}>پورتال خسارت</a>
                            </li> */}
          <li className="link">
            <Dropdown
              overlay={() => ContactUsMobile(props)}
              trigger={["click"]}
            >
              <a
                style={SubMenuMobile}
                className="ant-dropdown-link NavbarItem"
                onClick={(e) => e.preventDefault()}
              >
                تماس با ما <DownOutlined />
              </a>
            </Dropdown>
          </li>
          {/* <li>
                            <p style={{ fontFamily: "IranSans", fontSize: ".8em", color: "#57747E"}}><a>فا</a><span className="enBorderStyle"><a>EN</a></span></p>
                        </li> */}
        </ul>
      </nav>
    </div>
  );
};

export default Navbar;
